export default "__VITE_ASSET__BaLkQp1o__"